import React from 'react';
import Logo from '../../elements/logo/Logo';
import Nav from '../../common/header/Nav';
import StickyHeader from './StickyHeader';
// import { Link } from 'react-router-dom';
import SwitcherHeader from '../../elements/switcher/SwitcherHeader';
import MobileSidebar from './MobileSidebar';
import { FaBars } from 'react-icons/fa';

const HeaderFour = () => {

    const sticky = StickyHeader(100);


    return (
        <>
            <header className="header axil-header header-style-4">
                <div className={`axil-mainmenu ${sticky ? "axil-sticky" : ""}`}>
                    <div className="container">
                        <div className="header-navbar">
                            <div className="header-logo">
                                <Logo limage="/images/logo_sousa.png"
                                    dimage="/images/logo_sousa.png"
                                    simage="/images/logo_sousa.png"
                                />
                            </div>

                            {/* Desktop nav only */}
                            <div className="header-main-nav d-none d-lg-block">
                                <Nav />
                            </div>

                            {/* Mobile nav only */}
                            <div className="d-block d-lg-none w-100">
                                <MobileSidebar />
                            </div>

                            <div className="">
                                <ul className="list-group list-group-horizontal">
                                    <li className="d-block d-lg-none list-group-item">
                                        <button className="btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileSidebar" aria-controls="mobileSidebar" aria-label="Open mobile sidebar">
                                            <FaBars size={20} />
                                        </button>
                                    </li>
                                    <li className="my_switcher d-block d-lg-none list-group-item">
                                        <SwitcherHeader />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default HeaderFour;